import React, { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'
import ProjectItem from './ProjectItem'
function Projects() {
  const [letterClass, setLetterClass] = useState('text-animate')
  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])
  let projectList = [
    {
      link: 'https://ticketlock.netlify.app/',
      img: '/ticket.png',
      title: 'TicketLock',
    },
    {
      link: 'https://dynaskills-dynajobs.com/',
      img: '/dynaskills.png',
      title: 'Dynaskills-Dynajobs',
    },
    {
      link: 'https://kampina.netlify.app',
      img: '/kampina.png',
      title: 'Kampina',
    },
    {
      link: 'https://turnbrightnext.vercel.app/',
      img: '/turn.png',
      title: 'Turn B Right',
    },
    {
      link: 'https://creattives-thoughts.vercel.app/',
      img: '/thoughts.png',
      title: 'Creative Thoughts',
    },
  ]
  return (
    <>
      <div className="container contact-page flex flex-col-reverse justify-center">
        <div className="text-zone-project">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['P', 'r', 'o', 'j', 'e', 'c', 't', 's']}
              idx={15}
            />
          </h1>
        </div>
        <div className=" ml-[100px] mt-[100px] min-h-[300px] flex flex-wrap items-start gap-8">
          {projectList.map((link, i) => (
            <ProjectItem key={i} {...link} />
          ))}
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Projects
